import { jsx as _jsx } from "react/jsx-runtime";
import SearcherButton from "../../../searcher/searcher-button/index.js";
import { useSearcherFlightHotelProps } from "../../context/index.js";
import useButton from "./useButton.js";
const SearcherFlightHotelButton = (buttonProps)=>{
    const props = useSearcherFlightHotelProps();
    const { config  } = props ?? {};
    const { literals  } = config ?? {};
    const { submit =''  } = literals ?? {};
    const button = useButton(buttonProps);
    return /*#__PURE__*/ _jsx(SearcherButton, {
        ...button,
        children: submit
    });
};
export default SearcherFlightHotelButton;

//# sourceMappingURL=index.js.map